import React from "react";
import {
  StockOrder,
  StockOrderItem,
} from "@towersystems/roam-common/lib/generated-types";

export type ActiveStockOrderType = {
  stockOrder: StockOrder;
  setStockOrder: (stockOrder: StockOrder) => void;
};

export type ActiveStockOrderItemType = {
  item: StockOrderItem;
};

export const ActiveStockOrderContext = React.createContext<
  ActiveStockOrderType | undefined
>(undefined);

export const ActiveStockOrderItemContext = React.createContext<
  ActiveStockOrderItemType | undefined
>(undefined);
